import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkCardContainerComponent } from './link-card-container.component';
import { LinkCardComponent } from './link-card/link-card.component';
import { WmIconModule } from '../icon/index';
import { WmCardModule } from '../card/index';

@NgModule({
	declarations: [LinkCardContainerComponent, LinkCardComponent],
	imports: [CommonModule, WmIconModule, WmCardModule],
	exports: [LinkCardContainerComponent, LinkCardComponent]
})
export class WmLinkCardContainerModule {}
